import React, { Fragment, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { SetAdminQueryFlags } from 'src/constants/actionTypes'
import { useQuery } from 'src/utils/hooks/useQuery'

/**
 * Reads `showAllFields=true` from the URL and stores it in Redux on app load / navigation.
 */
export function AdminQueryFlagsBootstrap({ children }: { children: React.ReactNode }) {
  const dispatch = useDispatch()
  const { getQuery } = useQuery()

  useEffect(() => {
    const showAllFields = getQuery('showAllFields') === 'true'

    dispatch(SetAdminQueryFlags({ showAllFields }))
  }, [dispatch, getQuery])

  return <Fragment>{children}</Fragment>
}
